import { Card } from '@ott/auth';

const isVirtualCardDisabled = (cards: Card[] = []) => {
  return cards.reduce((result, card) => {
    if (!result && card.isOTTCard) {
      return card.isOTTCard;
    }

    return result;
  }, false);
};

export default isVirtualCardDisabled;
